import PropTypes from 'prop-types';

const BankCheckSvg = ({ width, height, palette = [] }) => {
  return (
    <svg
      width={`${width || 70}`}
      height={`${height || 70}`}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M49.3555 22.6953L51.4062 19.6191L53.457 22.6953H59.6094C63.0137 22.6953 65.7617 19.947 65.7617 16.543C65.7617 13.1387 63.0137 10.3906 59.6094 10.3906H53.457L51.4062 13.4668L49.3555 10.3906H26.7969L22.6953 16.543L26.7969 22.6953H49.3555ZM65.8984 35L61.7969 30.8984C61.7969 28.6426 55.8496 26.7969 53.5938 26.7969H2.05078C0.918203 26.7969 0 27.7151 0 28.8477V61.6602C0 62.7927 0.918203 63.7109 2.05078 63.7109H67.9492C69.0818 63.7109 70 62.7927 70 61.6602V43.2031C70 40.9473 68.1543 35 65.8984 35Z"
        fill={`url(#paint0_linear_504_8862${width + height})`}
      />
      <path
        d="M53.5938 26.7969C55.8496 26.7969 57.6953 28.6426 57.6953 30.8984V37.0508C57.6953 38.1834 58.6135 39.1016 59.7461 39.1016H65.8984C68.1543 39.1016 70 40.9473 70 43.2031C70 34.1385 62.6583 26.7969 53.5938 26.7969ZM10.3906 35C9.25709 35 8.33984 35.9172 8.33984 37.0508C8.33984 38.1843 9.25709 39.1016 10.3906 39.1016H18.5938C19.7273 39.1016 20.6445 38.1843 20.6445 37.0508C20.6445 35.9172 19.7273 35 18.5938 35H10.3906ZM39.2383 39.1016H47.4414C48.5749 39.1016 49.4922 38.1843 49.4922 37.0508C49.4922 35.9172 48.5749 35 47.4414 35H39.2383C38.1047 35 37.1875 35.9172 37.1875 37.0508C37.1875 38.1843 38.1047 39.1016 39.2383 39.1016ZM39.2383 43.2031H10.3906C9.25709 43.2031 8.33984 44.1204 8.33984 45.2539C8.33984 46.3874 9.25709 47.3047 10.3906 47.3047H39.2383C40.3718 47.3047 41.2891 46.3874 41.2891 45.2539C41.2891 44.1204 40.3718 43.2031 39.2383 43.2031ZM30.8984 51.4062H10.3906C9.25709 51.4062 8.33984 52.3235 8.33984 53.457C8.33984 54.5906 9.25709 55.5078 10.3906 55.5078H30.8984C32.032 55.5078 32.9492 54.5906 32.9492 53.457C32.9492 52.3235 32.032 51.4062 30.8984 51.4062ZM58.2962 47.9056L56.2033 49.9964C55.1719 48.5524 53.6318 47.3047 51.543 47.3047C50.5736 47.3047 49.7226 47.5731 48.9855 48.0056C48.609 47.5751 48.0562 47.3047 47.4414 47.3047C46.3079 47.3047 45.3906 48.2219 45.3906 49.3555V53.457C45.3906 54.4744 46.1356 55.3316 47.1429 55.4818C48.1322 55.6261 49.1116 55.0152 49.4061 54.0419C49.6564 53.2167 50.5436 51.4062 51.543 51.4062C52.5424 51.4062 53.4296 53.2167 53.6759 54.0338C53.8802 54.7288 54.435 55.2655 55.1359 55.4438C55.8101 55.6205 56.5708 55.4336 57.0946 54.9071L61.1961 50.8055C61.9972 50.0045 61.9972 48.7066 61.1961 47.9056C60.3951 47.1045 59.0972 47.1044 58.2962 47.9056ZM26.7969 10.3906C15.1895 10.3906 5.83789 14.4922 5.46875 14.6561C4.73047 14.9842 4.23828 15.7225 4.23828 16.543C4.23828 17.3634 4.73047 18.1016 5.46875 18.4296C5.83789 18.5937 15.1895 22.6953 26.7969 22.6953V10.3906ZM53.457 8.33984C53.457 7.19127 52.5548 6.28906 51.4062 6.28906C50.2577 6.28906 49.3555 7.19127 49.3555 8.33984V22.6953H53.457V8.33984Z"
        fill={`url(#paint1_linear_504_8862${width + height})`}
      />
      <defs>
        <linearGradient
          id={`paint0_linear_504_8862${width + height}`}
          x1="35"
          y1="63.7109"
          x2="35"
          y2="10.3906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[0]} />
          <stop offset="1" stopColor={palette[1]} />
        </linearGradient>
        <linearGradient
          id={`paint1_linear_504_8862${width + height}`}
          x1="37.1191"
          y1="55.5086"
          x2="37.1191"
          y2="6.28906"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={palette[2]} />
          <stop offset="1" stopColor={palette[3]} />
        </linearGradient>
      </defs>
    </svg>
  );
};

BankCheckSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  palette: PropTypes.arrayOf(PropTypes.string),
};

export default BankCheckSvg;
